/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Competitive_2_DetailInputs */

const en_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA senior major`)
};

const es_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Major sénior de la Iowa PGA`)
};

const de_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senioren-Major der Iowa PGA`)
};

const zh_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 元老组大赛`)
};

const ar_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بطولة كبرى لكبار Iowa PGA`)
};

const fr_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majeur senior de la Iowa PGA`)
};

const vi_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giải major senior Iowa PGA`)
};

const sw_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mashindano makuu ya wakongwe ya Iowa PGA`)
};

const th_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการเมเจอร์รุ่นซีเนียร์ของ Iowa PGA`)
};

const bs_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seniorski glavni turnir Iowa PGA`)
};

const ja_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA シニアメジャー`)
};

const ko_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 시니어 메이저 대회`)
};

const pt_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Major sênior da Iowa PGA`)
};

const it_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Major senior della Iowa PGA`)
};

const sv_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seniormajor i Iowa PGA`)
};

const nl_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior major van de Iowa PGA`)
};

const da_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seniormajor i Iowa PGA`)
};

const nb_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seniormajor i Iowa PGA`)
};

const fi_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA:n seniorien major-turnaus`)
};

const pl_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Major seniorów Iowa PGA`)
};

const ru_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мейджор Iowa PGA среди сеньоров`)
};

const tr_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA senior majör turnuvası`)
};

const hi_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA का सीनियर मेजर टूर्नामेंट`)
};

const id_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kejuaraan utama senior Iowa PGA`)
};

const ms_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kejohanan utama senior Iowa PGA`)
};

const cs_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seniorský major Iowa PGA`)
};

const el_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Major βετεράνων της Iowa PGA`)
};

const he_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טורניר מייג'ור לבכירים של Iowa PGA`)
};

const af_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA-seniormajor`)
};

const hu_about_content_competitive_2_detail = /** @type {(inputs: About_Content_Competitive_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Iowa PGA szenior majorja`)
};

/**
* | output |
* | --- |
* | "Iowa PGA senior major" |
*
* @param {About_Content_Competitive_2_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_competitive_2_detail = /** @type {((inputs?: About_Content_Competitive_2_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Competitive_2_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_competitive_2_detail(inputs)
	if (locale === "de") return de_about_content_competitive_2_detail(inputs)
	if (locale === "zh") return zh_about_content_competitive_2_detail(inputs)
	if (locale === "ar") return ar_about_content_competitive_2_detail(inputs)
	if (locale === "fr") return fr_about_content_competitive_2_detail(inputs)
	if (locale === "vi") return vi_about_content_competitive_2_detail(inputs)
	if (locale === "sw") return sw_about_content_competitive_2_detail(inputs)
	if (locale === "th") return th_about_content_competitive_2_detail(inputs)
	if (locale === "bs") return bs_about_content_competitive_2_detail(inputs)
	if (locale === "ja") return ja_about_content_competitive_2_detail(inputs)
	if (locale === "ko") return ko_about_content_competitive_2_detail(inputs)
	if (locale === "pt") return pt_about_content_competitive_2_detail(inputs)
	if (locale === "it") return it_about_content_competitive_2_detail(inputs)
	if (locale === "sv") return sv_about_content_competitive_2_detail(inputs)
	if (locale === "nl") return nl_about_content_competitive_2_detail(inputs)
	if (locale === "da") return da_about_content_competitive_2_detail(inputs)
	if (locale === "nb") return nb_about_content_competitive_2_detail(inputs)
	if (locale === "fi") return fi_about_content_competitive_2_detail(inputs)
	if (locale === "pl") return pl_about_content_competitive_2_detail(inputs)
	if (locale === "ru") return ru_about_content_competitive_2_detail(inputs)
	if (locale === "tr") return tr_about_content_competitive_2_detail(inputs)
	if (locale === "hi") return hi_about_content_competitive_2_detail(inputs)
	if (locale === "id") return id_about_content_competitive_2_detail(inputs)
	if (locale === "ms") return ms_about_content_competitive_2_detail(inputs)
	if (locale === "cs") return cs_about_content_competitive_2_detail(inputs)
	if (locale === "el") return el_about_content_competitive_2_detail(inputs)
	if (locale === "he") return he_about_content_competitive_2_detail(inputs)
	if (locale === "af") return af_about_content_competitive_2_detail(inputs)
	if (locale === "hu") return hu_about_content_competitive_2_detail(inputs)
	return en_about_content_competitive_2_detail(inputs)
});